module.exports = __webpack_public_path__ + "img/Application_4.2e0d3956.png";